import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import ChatGPTPage from '../chatGPT';
import {useAppSelector, useAppDispatch} from '../../store/hooks';
import {getUserInfo, selectUserInfo} from '../../store/user';
import {logout} from '../../request/token';
import MiddleHomePage from '../middleHome/middleHomePage';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import {Text, View, TouchableOpacity, Image} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import {CommonActions, useNavigation} from '@react-navigation/native';
export default function ChatGPTAssist() {
  const userInfo = useAppSelector(selectUserInfo);
  const grade = userInfo?.curriculumSetup?.xkwGradeId;
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const mountCountRef = useRef(0);
  const [isInitializing, setIsInitializing] = useState(true);
  // 获取用户信息
  useEffect(() => {
    const initializeUserInfo = async () => {
      if (!userInfo?.webExpireTime) {
        setIsInitializing(false);
        navigation.replace('UseCDK');
        return;
      }
      if (!userInfo?.curriculumSetup) {
        try {
          showGlobalLoading({
            text: '加载中...',
          });
          await dispatch(getUserInfo()).unwrap();
        } finally {
          hideGlobalLoading();
          setIsInitializing(false);
        }
      } else {
        setIsInitializing(false);
      }
    };
    setIsInitializing(false);
    initializeUserInfo();
  }, []); // 只在组件挂载时执行一次

  // 记录组件加载次数
  useEffect(() => {
    mountCountRef.current += 1;
    console.log('ChatGPTAssist 组件加载次数:', mountCountRef.current);
    return () => {
      console.log('ChatGPTAssist 组件卸载');
    };
  }, []);

  // 处理登出
  const handleLogout = () => {
    logout();
  };

  // 处理维护信息
  const handleMaintenance = useCallback(() => {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{name: 'Register', params: {isEdit: true, showModal: true}}],
      }),
    );
  }, [navigation]);
  // 修改内容渲染逻辑
  const content = useMemo(() => {
    if (!grade && !isInitializing) {
      return (
        <View style={styles.container}>
          <View style={styles.messageBox}>
            <Image
              source={{
                uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/newPad/gradeModalTips.png',
              }}
              style={styles.headerImage}
            />
            <Text style={styles.description}>
              新版本需要您重新维护当前账户的信息，以获得更好的服务体验。
            </Text>
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={[styles.button, styles.maintenanceButton]}
                onPress={handleMaintenance}>
                <Text style={styles.buttonText}>立即维护信息</Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={[styles.button, styles.logoutButton]}
                onPress={handleLogout}>
                <Text style={[styles.buttonText, styles.logoutText]}>
                  退出登录
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      );
    }

    if (grade && grade > 6) {
      return <MiddleHomePage />;
    }

    return <ChatGPTPage urlPath={'/AI/companionNew'} />;
  }, [grade, isInitializing, handleMaintenance]);

  // 如果正在初始化，返回 null 或 loading 组件
  if (isInitializing) {
    return null;
  }

  return content;
}

const styles = createStyles({
  container: {
    height: '100vh',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: 20,
  },
  messageBox: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    width: '50%',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  headerImage: {
    width: '8.05rem',
    height: '8.05rem',
    marginTop: '-6.05rem',
    marginBottom: '3rem',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  description: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: 15,
  },
  countdownText: {
    fontSize: 14,
    color: '#999',
    marginTop: 10,
  },
  buttonContainer: {
    width: '100%',
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 15,
  },
  button: {
    backgroundColor: '#007AFF',
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
    width: 150,
  },
  maintenanceButton: {
    backgroundColor: '#007AFF',
  },
  logoutButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#007AFF',
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  logoutText: {
    color: '#007AFF',
  },
});
